<main class="home-page">
  <h1 class="visually-hidden">{{ 'HOME_PAGE__ARTIFICIAL_INTELLIGENCE__TITLE' | translate }}</h1>

  <header>
    <div class="box">
      <div>
        <button
          routerLink="/login"
          class="es-btn es-btn-outline"
          [class.emp-btn-gradient]="isCompactLayout()"
          [class.emp-btn-outline]="isDesktopLayout()"
        >
          {{ 'LOGIN' | translate }}
        </button>
      </div>

      <div class="logo">
        <img ngSrc="assets/img/svg/esmart-logo.svg" alt="eSmart logo" width="240" height="64" priority />
      </div>

      <div>
        <button class="es-btn es-btn-outline" routerLink="/contact">
          {{ 'HOME_PAGE__CONTACT_US__BTN' | translate }}
        </button>
      </div>
    </div>
  </header>

  @if (isCompactLayout()) {
    <section class="box-container" aria-label="Home page highlights">
      <article class="box-info">
        <h2 class="box-title">{{ 'HOME_PAGE__ARTIFICIAL_INTELLIGENCE__TITLE' | translate }}</h2>
        <p class="box-paragraph">
          {{ 'HOME_PAGE__ARTIFICIAL_INTELLIGENCE__PARAGRAPH_1' | translate }}
        </p>
        <p class="box-paragraph">
          {{ 'HOME_PAGE__ARTIFICIAL_INTELLIGENCE__PARAGRAPH_2' | translate }}
        </p>
      </article>

      <div class="globe-img">
        <img
          ngSrc="assets/img/png/group_globe.png"
          alt="Illustration of a digital globe"
          width="288"
          height="530"
          priority
        />
      </div>

      <div class="button">
        <button class="es-btn es-btn-accented" routerLink="/">
          {{ 'HOME_PAGE__REQUEST_DEMO__BTN' | translate | uppercase }}
        </button>
      </div>

      <article class="box-info2">
        <h2 class="box-title">{{ 'HOME_PAGE__DATE_GATHERING__TITLE' | translate }}</h2>
        <p class="box-paragraph">{{ 'HOME_PAGE__DATE_GATHERING__PARAGRAPH_1' | translate }}</p>
        <p class="box-paragraph">{{ 'HOME_PAGE__DATE_GATHERING__PARAGRAPH_2' | translate }}</p>
      </article>

      <article class="box-info3">
        <h2 class="box-title">{{ 'HOME_PAGE__PROGNOSIS__TITLE' | translate }}</h2>
        <p class="box-paragraph">{{ 'HOME_PAGE__PROGNOSIS__PARAGRAPH' | translate }}</p>
      </article>

      <div class="battery-img">
        <img ngSrc="assets/img/png/battery.png" alt="Battery performance chart" width="240" height="190" />
      </div>

      <div class="button2">
        <button class="es-btn es-btn-accented" routerLink="/">
          {{ 'HOME_PAGE__REQUEST_DEMO__BTN' | translate | uppercase }}
        </button>
      </div>
    </section>
  }

  @if (isDesktopLayout()) {
    <section aria-label="Home page highlights">
      <div class="grid">
        <article class="roboto">
          <img
            ngSrc="assets/img/svg/emp-robot.svg"
            alt="Illustration of an energy assistant robot"
            class="object-fit-contain"
            width="108"
            height="180"
            priority
          />
          <div class="text-field">
            <h2>{{ 'HOME_PAGE__ARTIFICIAL_INTELLIGENCE__TITLE' | translate }}</h2>
            <p>{{ 'HOME_PAGE__ARTIFICIAL_INTELLIGENCE__PARAGRAPH_1' | translate }}</p>
            <p>{{ 'HOME_PAGE__ARTIFICIAL_INTELLIGENCE__PARAGRAPH_2' | translate }}</p>
          </div>
        </article>

        <div class="factory">
          <img
            ngSrc="assets/img/png/factory.png"
            alt="Industrial facility illustration"
            class="object-fit-contain"
            width="600"
            height="384"
          />
        </div>

        <article class="satelite">
          <img
            ngSrc="assets/img/png/Satellite.png"
            alt="Satellite illustration"
            class="object-fit-contain"
            width="195"
            height="266"
          />
          <div class="text-field">
            <h2>{{ 'HOME_PAGE__DATE_GATHERING__TITLE' | translate }}</h2>
            <p>{{ 'HOME_PAGE__DATE_GATHERING__PARAGRAPH_1' | translate }}</p>
            <p>{{ 'HOME_PAGE__DATE_GATHERING__PARAGRAPH_2' | translate }}</p>
          </div>
        </article>

        <article class="batteries">
          <img
            ngSrc="assets/img/png/battery.png"
            alt="Battery performance chart"
            class="object-fit-contain"
            width="240"
            height="190"
          />
          <div class="text-field">
            <h2>{{ 'HOME_PAGE__PROGNOSIS__TITLE' | translate }}</h2>
            <p>{{ 'HOME_PAGE__PROGNOSIS__PARAGRAPH' | translate }}</p>
          </div>
        </article>

        <div class="globe">
          <img
            ngSrc="assets/img/png/earth.png"
            alt="Earth illustration"
            class="object-fit-contain"
            width="500"
            height="500"
          />
        </div>
        <div class="demo-button">
          <button class="es-btn es-btn-accented" routerLink="/">
            {{ 'HOME_PAGE__REQUEST_DEMO__BTN' | translate | uppercase }}
          </button>
        </div>
      </div>
    </section>
  }
</main>
